import { render, staticRenderFns } from "./DeviceStatus.vue?vue&type=template&id=07a2149c&scoped=true&"
import script from "./DeviceStatus.vue?vue&type=script&lang=js&"
export * from "./DeviceStatus.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStatus.vue?vue&type=style&index=0&id=07a2149c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a2149c",
  null
  
)

export default component.exports